module.exports = __webpack_public_path__ + "img/bg40.2b6fb595.png";